import React from "react";
import { Left } from "./Left";
import { Right } from "./Right";
import "./home.less";

export function Home() {
    return (
        <div className="home">
            功能开发中...
        </div>
    )
}  